import Breadcrumbs from '@components/Breadcrumbs';
import Info from '@components/Info';
import { List, ListItem } from '@components/List';
import Container from '@components/UI/Container';
import Icon from '@components/UI/Icon';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';

import { Navigation } from "@layouts/NavigationV2"

import React from 'react';

const Legal = () => (
    <>
        <Navigation
            staticTheme="light"
            actionTheme="light"
        />

        <Breadcrumbs
            wrap
        />

        <Container className={"pb-14"}>
            <Info>
                <Heading
                    tag='h1'
                >
                    Legal
                </Heading>

                <Paragraph
                    tag='p'
                >
                    The following documents are an essential part of our legal terms:<br/>
                    You need to read and agree to each document to use Traqq
                </Paragraph>
            </Info>

            <div className='mb-10' />

            <List
                gap={ 4 }
                mods={ { bordered: true } }
            >
                <ListItem
                    action
                    href='/legal/terms'
                >
                    <Icon
                        name='chevron-right'
                        size={ 16 }
                        color='violet-700'
                    />

                    <span>Terms of Use</span>
                </ListItem>

                <ListItem
                    action
                    href='/legal/privacy'
                >
                    <Icon
                        name='chevron-right'
                        size={ 16 }
                        color='violet-700'
                    />

                    <span>Privacy Policy</span>
                </ListItem>
            </List>
        </Container>
    </>
);

export default Legal;
